// menu
// ***********************************************
(() => {
  const mbtn = document.querySelector('.js-mbtn');
  const mbtn2 = document.querySelector('.js-mbtn2');
  const body = document.body;

  if (!mbtn) return;

  mbtn.addEventListener('click', () => {
    body.classList.toggle('is-menuOpen');
  });
  mbtn2.addEventListener('click', () => {
    body.classList.toggle('is-menuOpen2');
  });
})();

// topset
// ***********************************************
(function() {

  const $otherMenu = $('.js-otherMenu');
  const $header = $('.js-header');
  const $anchor = $('.js-anchor');
  let headerHeight;
  function topSet() {
    headerHeight = $header.outerHeight();
    $otherMenu.css('top', headerHeight);
    $anchor.css('padding-top', headerHeight);
    $anchor.css('margin-top', -headerHeight);
  }

  topSet();

  $(window).on('load resize', function(){
    topSet();
  });

}());
